const US_ZIP_REGEX = /^(\d{5}(\-\d{4})?)$/;
const CA_ZIP_REGEX = /^\D\d\D(\-| |)?\d\D\d$/i;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Validate Postal Code
 * @param {string} postalCode
 * @returns Boolean based on whether the postal code is valid
 */
export const validatePostal = (postalCode = '') => {
	if (postalCode.match(US_ZIP_REGEX) === null && postalCode.match(CA_ZIP_REGEX) === null) {
		return false;
	}
	return true;
};

/**
 * Validate Email Address
 * @param {string} email
 * @returns Boolean based on whether the email is valid
 */
export const validateEmail = (email = '') => {
	if (email.match(EMAIL_REGEX) === null) {
		return false;
	}
	return true;
};

/**
 * Format Phone Number
 * @param {string} phone
 * @returns Formatted phone number as (###) ###-####
 */
export const formatPhoneNumber = (phone) => {
	const cleaned = ('' + phone).replace(/\D/g, '');
	const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

	if (match) {
		let international = match[1] ? '+1 ' : '';
		return [international, '(', match[2], ') ', match[3], '-', match[4]].join('');
	}

	return null;
};
